export default __webpack_public_path__ + "static/media/image_triple_50.ca53cd34.svg";